/** Official SoldX support contact — single source for footers, legal pages, Contact Us */

export const SUPPORT_COMPANY_LEGAL_NAME = "SoldX India Pvt Ltd"

export const SUPPORT_EMAIL = "soldxinfo@gmail.com"
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}` as const

export const SUPPORT_PHONE_1_HREF = "tel:+919056378448"
export const SUPPORT_PHONE_1_TEXT = "+91 90563 78448"
export const SUPPORT_PHONE_2_HREF = "tel:+918651243769"
export const SUPPORT_PHONE_2_TEXT = "+91 86512-43769"

/** WhatsApp wa.me path (digits only, country code, no +) */
export const SUPPORT_WHATSAPP_WA_ME = "https://wa.me/919056378448"

export const SUPPORT_CONTACT_INTRO = "For questions, concerns, or support, please contact:"
